import { useState } from "react";
import { Sparkles, X } from "lucide-react";

const WHATSAPP_NUMBER = "14153242122";
const WHATSAPP_TEXT = encodeURIComponent(
  "Hi SingVMS, I'd like to talk about integrating SingVMS with my CRM / systems and upgrading my account.",
);

export const whatsappContactUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

const DISMISS_KEY = "vms_upgrade_banner_dismissed";

export function UpgradeBanner() {
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "1",
  );

  function dismiss() {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  }

  if (dismissed) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 sm:gap-3 px-4 sm:px-6 py-2.5 bg-brand-50 border-b border-brand-100 text-sm">
      <Sparkles size={16} className="text-brand-600 shrink-0" />
      <p className="text-brand-900 flex-1 min-w-0">
        Need SingVMS integrated into your CRM or existing systems? We can support higher volume and custom integrations — you can upgrade anytime.
      </p>
      <div className="flex items-center gap-2 shrink-0">
        <a
          href={whatsappContactUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="px-3 py-1.5 bg-brand-500 text-white text-xs font-medium rounded-lg hover:bg-brand-700 transition-colors"
        >
          WhatsApp us
        </a>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="text-brand-400 hover:text-brand-700 transition-colors"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
